import { connect } from "react-redux";
import { Link } from "react-router-dom";
import React, { Component } from "react";
import Modal from "../../utils/customModal";
import DinamicTable from "../../shared/table";
import BillsStatus from "../../shared/status";
import TokenComponent from "../../shared/token";
import { withTranslation } from "react-i18next";
import { instanceAction } from "../../../Redux/api";
import ModalResults from "../../shared/modal/results";
import CheckBox from "../../shared/custom-components/checkbox";
import { logout } from "../../../Redux/actions/sessionActions";
import SecondaryButton from "canvas-core-react/lib/SecondaryButton";
import {
  getRoles,
  getSessionCountry,
  getSessionInfo,
} from "../../../Redux/reducer/session";
import { getCustomerCreditLine } from "../../../Redux/actions/credit-line";
import { MOD_BILL, WRITE, MOD_PROVID, EXECUTE } from "../../../permissions";
import {
  moduleAction,
  errorContainer,
  formatNumber,
  loadingModal,
  formatUTCDate,
} from "../../utils/functions";
import DeleteBillModal from "./DeleteBillModal";
import {
  getHolidaysByCountry,
  getisWithinWorkingHours,
} from "../../../Redux/reducer/users";
import { handleWorkingHours } from "../../utils/utilities";
import {
  getUserHolidayByCountry,
  workingHoursHandler,
} from "../../../Redux/actions/userActions";


export class TableBill extends Component {
  constructor(props) {
    super(props);
    this.onToggleModalDelete = this.onToggleModalDelete.bind(this);
    this.onSuccessDeleteBill = this.onSuccessDeleteBill.bind(this);
    this.state = {
      page: 0,
      sizePerPage: props.sizePerPage,
      provider: props.provider,
      selectedBills: [],
      checkAll: [],
      loading: false,
      showResults: false,
      deleteModal: false,
      results: {},
      modal: {
        show: false,
        content: null,
        onClose: undefined,
        showClose: false,
      },
      data: { approved: undefined },
      token: { show: false, code: null },
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.sizePerPage !== this.props.sizePerPage) {
      this.setState({ sizePerPage: this.props.sizePerPage, page: 0 });
      this.resetSelection();
    }

    if (
      JSON.stringify(prevProps.filters) !== JSON.stringify(this.props.filters)
    ) {
      this.resetSelection();
    }
  }

  componentWillUnmount() {
    this.resetSelection();
  }

  getHeaders = () => {
    const headers = [];
    const { page, checkAll } = this.state;
    const { mode, roles, t, session } = this.props;
    const isCaptureRole = moduleAction(roles, MOD_BILL, WRITE);
    const isApprovedRole = moduleAction(roles, MOD_BILL, EXECUTE);

    if (mode === "draft") {
      if (isApprovedRole || isCaptureRole) {
        headers.push({
          grow: 0,
          selector: "checkbox",
          name: (
            <CheckBox
              id={`checkbox-${page}`}
              label=""
              name="checkbox"
              onChange={(e) => this.checkAll(e)}
              checked={checkAll[`checkbox-${page}`]}
              disabled={!this.props?.isWithinWorkingHours}
            />
          ),
          center: true,
          bodyStyle: { flexGrow: 0 },
          cellFormatter: (row) =>
            this.checkInput(row.item, row.item.observaciones),
        });
      }
    }

    if (
      mode === "approved" ||
      mode === "paid_rejected" ||
      mode === "by-status" ||
      mode === "paid_rejected"
    ) {
      const isByStatusValid = mode === "by-status";
      const isApprovedValid = mode === "approved";
      const isPaidRejected = mode === "paid_rejected";

      if (
        isByStatusValid ||
        isApprovedValid ||
        (isPaidRejected && isApprovedRole)
      ) {
        headers.push({
          grow: 0,
          selector: "checkbox",
          name: (
            <CheckBox
              id={`checkbox-${page}`}
              label=""
              name="checkbox"
              onChange={(e) => this.checkAll(e)}
              checked={checkAll[`checkbox-${page}`]}
              disabled={!this.props?.isWithinWorkingHours}
            />
          ),
          center: true,
          bodyStyle: { flexGrow: 0 },
          cellFormatter: (row) =>
            this.checkInput(row.item, row.item.observaciones),
        });
      }
    }

    headers.push({
      selector: "fechaCarga",
      name: t("invoices.table.headers.fechaCarga"),
    });

    if (session.allCompanies === true) {
      headers.push({
        selector: "companyName",
        name: t("invoices.table.headers.companyName"),
        cellFormatter: (row) => (
          <p
            className="TextCaption__text TableBody__cellItem"
            title={row.companyName}
          >
            {row.companyName}
          </p>
        ),
      });
    }

    headers.push(
      { selector: "numFactura", name: t("invoices.table.headers.numFactura") },
      { selector: "name", name: t("invoices.table.headers.name") },
      {
        selector: "cedJuridica",
        name: t("invoices.table.headers.cedJuridica"),
        cellFormatter: (row) => (
          <p
            className="TextCaption__text TableBody__cellItem"
            title={row.cedJuridica}
          >
            {row.cedJuridica}
          </p>
        ),
      },
      { selector: "accion", name: t("invoices.table.headers.reference") },
      {
        selector: "fechaEmision",
        name: t("invoices.table.headers.fechaEmision"),
      },
      { selector: "monto", name: t("invoices.table.headers.monto") },
      {
        selector: "fechaVencimiento",
        name: t("invoices.table.headers.fechaVencimiento"),
      }
    );

    if (mode !== "draft") {
      headers.push({
        selector: "status",
        name: t("invoices.table.headers.status"),
        center: true,
      });
    } else {
      headers.push({
        selector: "observaciones",
        name: t("invoices.table.headers.observaciones"),
      });
    }
    return headers;
  };

  checkAll = (event) => {
    const selectedBills = { ...this.state.selectedBills };

    const billSelection = JSON.parse(JSON.stringify(this.props.defaultBillSelection ?? {}));

    if (this.props.billSelection) {
      this.props.handleBillSelection(this.props.defaultBillSelection);
    }

    const {
      data,
      updateCreditLine,
      session: { allCompanies },
    } = this.props;
    const checkAll = { ...this.state.checkAll };

    const mounts = {};

    data.map((item) => {
      const billId = `invoice-${item.billId}-${item.cedJuridica}`;
      let stateMount = 0;
      if (allCompanies === true) {
        if (mounts[item.company.id] === undefined) {
          mounts[item.company.id] = {};
        }
        stateMount =
          mounts[item.company.id][item.currencyDetail.currencyCode] || 0;
      } else {
        stateMount = mounts[item.currencyDetail.currencyCode] || 0;
      }

      if (!event.target.checked && selectedBills[billId] !== undefined) {
        delete selectedBills[billId];
        if (item.toBIllDiscount === true) {
          if (allCompanies === true) {
            mounts[item.company.id][item.currencyDetail.currencyCode] =
              stateMount + item.monto;
          } else {
            mounts[item.currencyDetail.currencyCode] = stateMount + item.monto;
          }
        }
        // monto = monto + item.monto;
      } else if (event.target.checked) {
        if (
          selectedBills[billId] === undefined &&
          item.toBIllDiscount === true
        ) {
          if (allCompanies === true) {
            mounts[item.company.id][item.currencyDetail.currencyCode] =
              stateMount + item.monto;
          } else {
            mounts[item.currencyDetail.currencyCode] = stateMount + item.monto;
          }
          // monto = monto + item.monto;
        }
        if (this.props.mode === "by-status" && item.status === "DELETED") {
          console.log(
            `Factura ${item.numFactura} ya eliminada. Mas info. CAREVFACT-5532`
          );
        } else {
          if (!this.props.excludedStatus.includes(item.status)) {
            selectedBills[billId] = {
              id: item.billId,
              billNumber: item.numFactura,
              billStatus: item.status,
              providerId: item.providerId,
              ...item,
            };
          }
          this.addBillSelection(billSelection, item);
        }
      }
    });

    checkAll[event.target.id] = !checkAll[event.target.id];

    if (this.props.billSelection) {
      this.props.handleBillSelection(billSelection);
    }

    this.setState({ selectedBills, checkAll });
    if (undefined !== updateCreditLine) {
      if (allCompanies === true) {
        Object.keys(mounts).map((companyId) =>
          Object.keys(mounts[companyId]).map((currency) =>
            updateCreditLine(
              currency,
              mounts[companyId][currency],
              event.target.checked,
              false,
              companyId
            )
          )
        );
      } else {
        Object.keys(mounts).map((key) =>
          updateCreditLine(key, mounts[key], event.target.checked)
        );
      }
    }
  };

  addBillSelection = (billSelection, item) => {
    if (!this.props.billSelection) return;

    /* istanbul ignore else */
    if (!this.props.excludedStatus.includes(item.status)) {
      billSelection.totalBillSelection++;
      const billPerCurrency =
        billSelection.currency[item.currencyDetail.currencyCode];
      billPerCurrency.totalBillSelection++;
      billPerCurrency.totalBillAmount += item.monto * 100;
      if (item.toBIllDiscount) {
        billPerCurrency.billTypeSelection.discount.totalBillSelection++;
        billPerCurrency.billTypeSelection.discount.totalBillAmount += item.monto * 100;
      } else {
        billPerCurrency.billTypeSelection.paymentMaturity.totalBillSelection++;
        billPerCurrency.billTypeSelection.paymentMaturity.totalBillAmount += item.monto * 100;
      }
    }
  };

  removeBillSelection = (billSelection, item) => {
    if (!this.props.billSelection) return;

    /* istanbul ignore else */
    if (!this.props.excludedStatus.includes(item.status)) {
      billSelection.totalBillSelection--;
      const billPerCurrency = billSelection.currency[item.currencyDetail.currencyCode];
      billPerCurrency.totalBillSelection--;
      billPerCurrency.totalBillAmount -= item.monto * 100;
      if (item.toBIllDiscount) {
        billPerCurrency.billTypeSelection.discount.totalBillSelection--;
        billPerCurrency.billTypeSelection.discount.totalBillAmount -= item.monto * 100;
      } else {
        billPerCurrency.billTypeSelection.paymentMaturity.totalBillSelection--;
        billPerCurrency.billTypeSelection.paymentMaturity.totalBillAmount -= item.monto * 100;
      }

      if (billPerCurrency.totalBillSelection === 0) {
        billPerCurrency.totalBillAmount = 0;
        billPerCurrency.billTypeSelection.discount.totalBillAmount = 0;
        billPerCurrency.billTypeSelection.paymentMaturity.totalBillAmount = 0;
      }
    }
  };

  handleTableChange = ({ page, sizePerPage }) => {
    this.resetSelection();
    const { getBillsList } = this.props;
    // var sortFilter =
    //   property !== "" && property !== null ? `${property},${sort}` : "id,DESC";

    return getBillsList(page, sizePerPage, this.props.filters).then(() => {
      this.setState({ page, sizePerPage });
    });
  };

  changeSelected = (event) => {
    const selectedBills = { ...this.state.selectedBills };
    const billSelection = JSON.parse(JSON.stringify(this.props.billSelection ?? {}));
    const {
      data,
      mode,
      updateCreditLine,
      session: { allCompanies },
    } = this.props;

    const billId = event.target.id.split("-")[1];

    let currentBill = {};
    let currency = "";

    data.map((bill) => {
      if (`${bill.billId}` === billId) {
        currentBill = { ...bill };
        currency = bill.currencyDetail.currencyCode;
      }
    });

    if (
      !event.target.checked &&
      selectedBills[event.target.name] !== undefined
    ) {
      this.removeBillSelection(billSelection, currentBill);
      delete selectedBills[event.target.name];
    } else if (event.target.checked) {
      if (mode === "by-status" && currentBill.status === "DELETED") {
        console.log(
          `Factura ${currentBill.numFactura} ya eliminada. Mas info. CAREVFACT-5532`
        );
      } else {
        selectedBills[event.target.name] = {
          id: currentBill.billId,
          billNumber: currentBill.numFactura,
          billStatus: currentBill.status,
          providerId: currentBill.providerId,
          ...currentBill,
        };
        this.addBillSelection(billSelection, currentBill);
      }
    }

    if (this.props.billSelection) {
      this.props.handleBillSelection(billSelection);
    }

    this.setState({ selectedBills });
    if (undefined !== updateCreditLine && currentBill.toBIllDiscount === true) {
      if (allCompanies === true) {
        updateCreditLine(
          currency,
          currentBill.monto,
          event.target.checked,
          false,
          currentBill.company.id
        );
      } else {
        updateCreditLine(currency, currentBill.monto, event.target.checked);
      }
    }
  };

  checkInput = (item) => {
    const { selectedBills } = this.state;
    const { roles, mode } = this.props;
    const billId = `invoice-${item.billId}-${item.cedJuridica}`;
    const check = selectedBills[billId] !== undefined;
    let checkProps = {
      key: billId,
      id: billId,
      label: ``,
      name: billId,
      onChange: (e) => this.changeSelected(e),
      checked: check,
      disabled: !this.props?.isWithinWorkingHours,
    };

    const isCaptureRole = moduleAction(roles, MOD_BILL, WRITE);
    const isApprovedRole = moduleAction(roles, MOD_BILL, EXECUTE);

    const statusApprovedValid = ["DRAFT"];
    const statusValid = [
      "DRAFT",
      "PENDING",
      "APPROVED",
      "APPROVED_PARTIALLY",
      "DDAY",
    ];

    const isDraftValid = mode === "draft";

    const isByStatusValid = mode === "by-status";
    const isApprovedValid = mode === "approved";
    const isPaidRejected = mode === "paid_rejected";

    if (
      isDraftValid ||
      isApprovedValid ||
      (isPaidRejected && isApprovedRole) ||
      (isByStatusValid && isCaptureRole && statusValid.includes(item.status)) ||
      (isByStatusValid &&
        isApprovedRole &&
        statusApprovedValid.includes(item.status))
    ) {
      return <CheckBox {...checkProps} />;
    }

    return <span />;
  };

  resetSelection = () => {
    if (undefined !== this.props.updateCreditLine) {
      this.props.updateCreditLine("", 0, false, true);
    }

    if (this.props.billSelection) {
      this.props.handleBillSelection(this.props.defaultBillSelection);
    }

    this.setState({
      selectedBills: [],
      checkAll: [],
      token: { show: false, code: null },
    });
  };

  setTableData = () => {
    var { data, roles, t } = this.props;
    var dataResult = [];

    if (data.length > 0) {
      data.map((item) => {
        var symbol =
          item.currencyDetail !== undefined
            ? item.currencyDetail.currencySymbol
            : "";
        var billObj = {
          fechaCarga: new Date(item.fechaCarga).toLocaleDateString("es-ES"),
          numFactura: (
            <Link to={`/bills/${item.billId}/info`}>{item.numFactura}</Link>
          ),
          name:
            roles[MOD_PROVID] !== undefined ? (
              <Link to={`/providers/${item.providerId}/profile`}>
                {item.name}
              </Link>
            ) : (
              item.name
            ),
          cedJuridica: item.cedJuridica,
          fechaEmision: formatUTCDate(item.fechaEmision),
          monto: formatNumber(item.monto, symbol),
          fechaVencimiento: formatUTCDate(item.fechaVencimiento),
          accion: item.referenceNumber,
          status: <BillsStatus statusCode={item.status} />,
          observaciones:
            false === item.observaciones
              ? t("invoices.table.pendingData")
              : item.isDraftStatusMessage
              ? "Factura no procesada. Valide el detalle del error en el correo enviado antes de reprocesar."
              : "",
          companyName: item.company.companyName || "",
          item,
        };

        dataResult.push(billObj);
      });
    }

    return dataResult;
  };

  validate = ({ validToken = null }) => {
    if (validToken === null) {
      this.setState({ token: { show: true } });
    } else {
      this.setState({ token: { show: true, code: validToken } }, () =>
        this.approvedBills(this.state.data.approved)
      );
    }
  };

  holidayCheckHandler = async (callback) => {
    const { countryCode } = this.props;
    try {
      await this.props.getUserHolidayByCountry(countryCode);
      callback();
    } catch (error) {
      this.props.workingHoursHandler({
        isWithinWorkingHours: false,
        holidayStatusOk: false,
      });
    }
  };

  handleAllowedDate = () => {
    const { countryCode, holidaysByCountryCode } = this.props;
    if (this.props.mode !== "by-status") {
      const isWithinWorkingHours = handleWorkingHours(countryCode);
      if (holidaysByCountryCode?.isHoliDay || !isWithinWorkingHours) {
        this.props.workingHoursHandler({
          isWithinWorkingHours: false,
          holidayStatusOk: true,
        });
      }

      return holidaysByCountryCode?.isHoliDay || !isWithinWorkingHours;
    }

    return false;
  };

  approvedBills = (approved = true) => {
    const { selectedBills, data, token } = this.state;
    const bills = [];
    const { session } = this.props;

    const isNotAllowedDate = this.handleAllowedDate();

    if (isNotAllowedDate) {
      this.resetSelection();
      return;
    }

    if (true === this.props.needToken && token.code === null) {
      this.setState({ token: { show: true }, data: { approved } });
      return true;
    }

    this.setState({ loading: true });
    const approvedData = data.approved !== undefined ? data.approved : approved;

    const apiHeader =
      token.code !== null ? { "x-security-code": token.code } : {};

    Object.keys(selectedBills).map((key) => {
      const isDeletePending = selectedBills[key].status === "DELETE_PENDING";
      let status = this.props.rejectedTo;

      if (approvedData) {
        status = isDeletePending ? "DELETE_PENDING" : this.props.approvedTo;
      }

      return bills.push({
        status,
        billId: selectedBills[key].id,
      });
    });

    return this.props
      .instanceAction("/bills/update-status", "put", bills, apiHeader)
      .then((data) => {
        //clear selection
        this.resetSelection();
        // mandamos a refrescar la linea de crédito
        if (true === this.props.updateOnSubmit) {
          //prueba del bug CAREVFACT-4597
          if (session.allCompanies !== true) {
            this.props.getCustomerCreditLine();
          }
        }
        this.setState({
          loading: false,
          showResults: true,
          results: data.data.data,
          token: { show: false, code: null },
          successfullyRejected: false,
        });
      })
      .catch((err) => {
        const { modal } = this.state;
        switch (err.response.status) {
          case 401:
            return this.props.logout();
          default:
            modal.show = true;
            modal.showClose = true;
            modal.onClose = () =>
              this.setState({
                modal: {
                  show: false,
                  content: null,
                  onClose: undefined,
                  showClose: false,
                },
              });
            modal.content = errorContainer(
              this.props.t("general.labels.errorTitle"),
              err.response.data.notifications[0].description
            );
        }
        //clear selection
        this.resetSelection();
        this.setState({
          loading: false,
          modal,
          token: { show: false, code: null },
        });
      });
  };

  closeResults = () => {
    this.setState({ showResults: false, results: {} });
    // Data reload
    this.handleTableChange({ page: 0, sizePerPage: this.state.sizePerPage });
  };

  onToggleModalDelete() {
    const isNotAllowedDate = this.handleAllowedDate();

    if (isNotAllowedDate) {
      this.resetSelection();
      return;
    }
    this.setState({ deleteModal: !this.state.deleteModal });
  }

  onSuccessDeleteBill = () => {
    const { page, sizePerPage } = this.state;
    this.handleTableChange({ page, sizePerPage });
    this.resetSelection();

    this.onToggleModalDelete();
  };

  getActions = () => {
    const { t, mode } = this.props;
    const billsLength = Object.keys(this.state.selectedBills).length;
    const clearProps =
      billsLength > 0
        ? {
            className: `btnLimpiar`,
            onClick: () => this.resetSelection(),
            disabled: !this.props?.isWithinWorkingHours,
          }
        : { className: `btnLimpiar`, disabled: true };

    const deleteProps =
      billsLength > 0
        ? {
            className: `btnRemove`,
            onClick: () => this.holidayCheckHandler(this.onToggleModalDelete),
            disabled: !this.props?.isWithinWorkingHours,
          }
        : { className: `btnRemove`, disabled: true };

    const processProps =
      billsLength > 0
        ? {
            className: `btnProcesar`,
            onClick: () => this.holidayCheckHandler(this.approvedBills),
            disabled: !this.props?.isWithinWorkingHours,
          }
        : { className: `btnProcesar`, disabled: true };

    const rejectProps =
      billsLength > 0
        ? {
            className: `btnRechazar`,
            onClick: () =>
              this.holidayCheckHandler(() => this.approvedBills(false)),
            disabled: !this.props?.isWithinWorkingHours,
          }
        : { className: `btnRechazar`, disabled: true };

    const isCaptureRole = moduleAction(this.props.roles, MOD_BILL, WRITE);
    const isApprovedRole = moduleAction(this.props.roles, MOD_BILL, EXECUTE);
    const isPaidRejectedMode = mode === "paid_rejected";
    const isApprovedMode = mode === "approved";

    return this.props.needActions ? (
      <div className="form-actions clearfix">
        {(isApprovedMode || isCaptureRole || isApprovedRole) && (
          <SecondaryButton id={`clear-btn`} {...clearProps}>
            {t("general.buttons.clear")}
          </SecondaryButton>
        )}

        {!isApprovedMode &&
          !isPaidRejectedMode &&
          (isCaptureRole || isApprovedRole) && (
            <SecondaryButton id={`delete-btn`} {...deleteProps}>
              {t("general.buttons.remove")}
            </SecondaryButton>
          )}

        {(isApprovedMode || isPaidRejectedMode) && (
          <SecondaryButton id={`reject-btn`} {...rejectProps}>
            {t("general.buttons.rejected")}
          </SecondaryButton>
        )}
        {!this.props.notApproved &&
          (isApprovedMode || isPaidRejectedMode) &&
          isApprovedRole && (
            <SecondaryButton id={`aprove-btn`} {...processProps}>
              {t("general.buttons.process")}
            </SecondaryButton>
          )}
        {mode === "draft" && isCaptureRole && (
          <SecondaryButton id={`process-btn`} {...processProps}>
            {t("general.buttons.process")}
          </SecondaryButton>
        )}
      </div>
    ) : null;
  };

  getClassByTable() {
    const { mode, roles } = this.props;
    const havePerm = moduleAction(roles, MOD_BILL, WRITE);
    const isApprovedRole = moduleAction(this.props.roles, MOD_BILL, EXECUTE);
    const isPaidRejectedMode = mode === "paid_rejected";

    if (isPaidRejectedMode && !isApprovedRole) return "";
    if (mode !== "by-status" && havePerm) return "checkbox-table";
    return "";
  }

  render() {
    const {
      page,
      sizePerPage,
      loading,
      showResults,
      results,
      modal,
      token,
      deleteModal,
      selectedBills,
    } = this.state;
    const { totalSize, mode, needToken } = this.props;

    return (
      <>
        <DinamicTable
          className={this.getClassByTable()}
          data={this.setTableData()}
          headers={this.getHeaders()}
          page={page}
          totalSize={totalSize}
          sizePerPage={sizePerPage}
          onTableChange={this.handleTableChange}
          actions={this.getActions()}
        />
        {needToken === true && token.show === true && (
          <TokenComponent
            send={this.validate}
            goBack={() => this.setState({ token: { show: false, code: null } })}
          />
        )}
        {loading && loadingModal()}
        {showResults && (
          <ModalResults
            mode={mode}
            results={results}
            closeModal={this.closeResults}
          />
        )}
        <Modal
          show={modal.show}
          handleClose={modal.onClose}
          showClose={modal.showClose}
        >
          {modal.content}
        </Modal>
        <DeleteBillModal
          show={deleteModal}
          selectedBills={selectedBills}
          onOk={this.onSuccessDeleteBill}
          onCancel={this.onToggleModalDelete}
          instanceAction={this.props.instanceAction}
        />
      </>
    );
  }
}

TableBill.defaultProps = {
  action: null,
  actionlbl: "",
  needActions: true,
  updateOnSubmit: false,
};

export const mapStateToProps = (state) => {
  return {
    roles: getRoles(state),
    session: getSessionInfo(state),
    isWithinWorkingHours: getisWithinWorkingHours(state),
    countryCode: getSessionCountry(state),
    holidaysByCountryCode: getHolidaysByCountry(state),
  };
};

export const mapDispatch = (dispatch) => {
  return {
    logout: () => dispatch(logout()),
    getCustomerCreditLine: () => dispatch(getCustomerCreditLine()),
    instanceAction: (apiUrl, method, data, headers) =>
      dispatch(instanceAction(apiUrl, method, data, headers)),
    getUserHolidayByCountry: (payload) =>
      dispatch(getUserHolidayByCountry(payload)),
    workingHoursHandler: (payload) => dispatch(workingHoursHandler(payload)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatch
)(withTranslation()(TableBill));
